import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowForward, IoMdEyeOff } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";
import { useReprocessingShareDataMutation } from "../../services/shareDataService";

function ProccessingDataComponent({
  proccesDataList,
  setProccesDataList,
  selectedChat,
  processingLoading,
}) {
  const [loading, setLoading] = useState(false);
  const [reprocessingShareData] = useReprocessingShareDataMutation();
  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  const resendHandler = (data) => {
    setLoading(false);
    reprocessingShareData({ batch_id: data?.batch_id })?.then((res) => {
      setLoading(false);
    });
  };
  return (
    <div>
      <div className="grid grid-cols-6 bg-teal1000 text-white px-3 py-1">
        <div>Generated On</div>
        <div>Generated By</div>
        <div>Status</div>
      </div>
      {processingLoading && <i className="text-center">Loading...</i>}
      {proccesDataList?.map((v, k) => (
        <>
          <div className="grid grid-cols-6 px-3 py-2 border flex items-center">
            <div className="flex items-center cursor-pointer select-none">
              <span
                onClick={() => {
                  let processList = cloneDeep(proccesDataList);
                  processList[k].toggle = !processList[k].toggle;
                  setProccesDataList(processList);
                }}
              >
                {v?.toggle ? (
                  <IoIosArrowDown size={20} />
                ) : (
                  <IoIosArrowForward size={20} />
                )}
              </span>
              {moment(v?.ShareDataTransaction?.created).format(
                "MM/DD/YYYY hh:mm A"
              )}
            </div>
            <div>{v?.SharedBy?.fname + " " + v?.SharedBy?.lname}</div>
            <div className="cursor-pointer capitalize">
              {v?.ShareDataTransaction?.failed == "1" ? (
                <>
                  Failed{" "}
                  <span
                    className="text-red-500 cursor-pointer"
                    onClick={() => resendHandler(v?.ShareDataTransaction)}
                  >
                    (Resend)
                  </span>
                </>
              ) : (
                v?.ShareDataTransaction?.status
              )}
            </div>
          </div>
          <>
            {v?.toggle && (
              <div className="border-4 divide-y-2">
                {v?.ShareDataTransaction?.details?.map((detailData) => (
                  <div className=" grid grid-cols-6 px-3 py-2 flex items-center">
                    <div
                      className="col-span-2"
                      dangerouslySetInnerHTML={{ __html: detailData?.title }}
                    />
                    <div className="capitalize">{detailData?.type}</div>
                    <div className="flex ml-10 ">
                      {detailData?.content ? (
                        <>
                          <FaEye
                            onClick={() => {
                              window.open(
                                `${
                                  process.env.REACT_APP_API_URL_V1
                                }/utilities/get_attachment.json?attachment=${
                                  detailData?.content
                                }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`,
                                "_blank"
                              );
                            }}
                            size={20}
                            className="text-sky-700 cursor-pointer"
                          />
                        </>
                      ) : (
                        <>
                          <IoMdEyeOff size={20} />
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        </>
      ))}
    </div>
  );
}

export default ProccessingDataComponent;
